import { RouteEntry } from 'framework/routing/routeEntry';

import { DesignerPageProps } from './types';

export function getRoute(): RouteEntry<DesignerPageProps> {
	return {
		url: '/dashboards/designer-v2/:id',
		getModuleImport: async () => await import('./designerPage'),
		routeId: 'dashboards_designer_v2',
	};
}
